import { Avatar, Button, Grid, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

import iconUrl from "@/assets/icons/home/rocket.svg";
import { ROUTES } from "@/utils/navigation";

import DescriptionList from "./components/DescriptionList";
import Section from "@/components/Section";
import {
  TitleWrapperStyles,
  descriptionPartStyles,
  iconStyles,
} from "./styles";

const Plans = () => {
  return (
    <Section
      pt={{ xs: 5, md: 12.5, lg: 17.5 }}
      pb={{ xs: 5, md: 12.5, lg: 17.5 }}
    >
      <Grid container>
        <Grid item xs={12} md={6}>
          <Box sx={TitleWrapperStyles}>
            <Typography
              variant="h2"
              color="text.primary"
              mb={2}
              maxWidth={{ md: 495 }}
            >
              We’ve Got a Plan for Everyone
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              mb={{ xs: 4, md: 11 }}
              maxWidth={{ md: 575 }}
            >
              Compare our subscriptions, features, devices, and plans to choose
              the right solution for you.
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight={700}
              mb={{ xs: 5, md: 3 }}
            >
              Starting from $9.99
            </Typography>

            <Button
              variant="contained"
              component={Link}
              fullWidth
              to={ROUTES.subscriptionPlans}
            >
              Explore plans
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={descriptionPartStyles}>
            <Box position="relative">
              <DescriptionList />
            </Box>
            <Typography
              display="flex"
              component="div"
              gap={{ xs: 1.5, md: 2.5 }}
              variant="subtitle2"
              fontWeight={700}
              alignItems="start"
              sx={{ width: "100%" }}
              justifyContent="start"
            >
              <Avatar src={iconUrl} sx={iconStyles} />
              Join thousands of satisfied business and personal users and
              discover the Trackmate difference.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
};

export default Plans;
